// extracted by mini-css-extract-plugin
module.exports = {"diffContent":"DiffContent_diffContent__3Wxak","joinSymbol":"DiffContent_joinSymbol__2zG5c","currentValue":"DiffContent_currentValue__2J7VJ"};